/** @format */

import React, { useEffect, useState } from "react";
import moment from "moment";
import usePermissions from "../../permissions/permission";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import Cookies from "js-cookie";
const Supervisors = () => {
  const [data, setData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [employeeNumber, setEmployeeNumber] = useState("");
  const [employeeData, setEmployeeData] = useState({
    employee_fullname: "",
    employee_email: "",
    employee_contact_no: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [supervisorToDelete, setSupervisorToDelete] = useState(null);

  const { hasPermission } = usePermissions();
  const API_URL = process.env.REACT_APP_FRONTEND_URL;
  const itemsPerPage = 10;
  const token = Cookies.get("user_token");

  useEffect(() => {
    // This should ideally be a paginated endpoint
    fetchSupervisors();
  }, [currentPage]);

  const fetchSupervisors = () => {
    fetch(`${API_URL}/v1/hris/supervisors/getSupervisors`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (Array.isArray(result)) {
          setData(result);
        } else {
          console.error("Expected an array but got:", result);
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
      });
  };
  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (employeeNumber.trim().length < 3) {
        setEmployeeData({
          employee_fullname: "",
          employee_email: "",
          employee_contact_no: "",
        });
        return;
      }
      try {
        const response = await fetch(
          `${API_URL}/v1/hris/employees/personal/${employeeNumber}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        if (result.success && result.data) {
          const empData = result.data;
          setEmployeeData({
            employee_fullname: empData.employee_fullname || "",
            employee_email: empData.employee_email || "",
            employee_contact_no: empData.employee_contact_no || "",
          });
        } else {
          setEmployeeData({
            employee_fullname: "Not Found",
            employee_email: "",
            employee_contact_no: "",
          });
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      }
    };
    const handler = setTimeout(() => {
      fetchEmployeeDetails();
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [employeeNumber, API_URL]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    const payload = {
      supervisor_employee_no: employeeNumber,
      supervisor_fullname: employeeData.employee_fullname,
      supervisor_email: employeeData.employee_email,
      supervisor_contact_no: employeeData.employee_contact_no,
    };
    try {
      const response = await fetch(
        `${API_URL}/v1/hris/supervisors/addSupervisorWithEmployees`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create supervisor.");
      }
      setSuccessMessage("Supervisor created successfully!");
      setTimeout(() => {
        togglePopup();
        fetchSupervisors();
      }, 2000);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (supervisor) => {
    setSupervisorToDelete(supervisor);
    setIsDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!supervisorToDelete) return;
    try {
      const response = await fetch(
        `${API_URL}/v1/hris/supervisors/deleteSupervisor?supervisor_id=${supervisorToDelete.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok) {
        fetchSupervisors();
        setIsDeleteConfirmOpen(false);
        setSupervisorToDelete(null);
      } else {
        throw new Error("Failed to delete supervisor");
      }
    } catch (error) {
      console.error("Error deleting supervisor:", error);
      alert("An error occurred while deleting the supervisor.");
      setIsDeleteConfirmOpen(false);
    }
  };

  const cancelDelete = () => {
    setIsDeleteConfirmOpen(false);
    setSupervisorToDelete(null);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
    if (!isPopupOpen) {
      setEmployeeNumber("");
      setEmployeeData({
        employee_fullname: "",
        employee_email: "",
        employee_contact_no: "",
      });
      setSuccessMessage("");
      setErrorMessage("");
    }
  };

  return (
    <div className="font-montserrat">
      <div className="flex justify-between items-center mt-6">
        <p className="text-[25px] ">Supervisors</p>
      </div>

      {hasPermission(10039) && (
        <div className="mt-5">
          <button
            className="px-5 py-2 bg-blue-500 text-white rounded-md shadow-sm hover:bg-blue-600"
            onClick={togglePopup}
          >
            Create Supervisor
          </button>
        </div>
      )}

      <div className="mt-5 shadow-lg p-3 rounded-lg bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Employee No
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Full Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Contact No
              </th>
              {hasPermission(2070) && (
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Action
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data.map((item) => (
              <tr key={item.id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  {item.supervisor_employee_no}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {item.supervisor_fullname}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {item.supervisor_email}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {item.supervisor_contact_no}
                </td>
                {hasPermission(10040) && (
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button
                      onClick={() => handleDeleteClick(item)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FaTrashAlt />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-between items-center mt-4">
          <div>
            <span className="text-sm text-gray-700">
              Showing{" "}
              {data.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0} to{" "}
              {Math.min(currentPage * itemsPerPage, totalRecords)} of{" "}
              {totalRecords} results
            </span>
          </div>
          <div className="flex items-center gap-2">
            <button
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages > 0 ? totalPages : 1}
            </span>
            <button
              className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-900 bg-opacity-50">
          <div className="w-full max-w-lg bg-white rounded-lg shadow-lg flex flex-col">
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="text-xl font-semibold">Create Supervisor</h2>
              <button
                onClick={togglePopup}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Employee ID
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 p-2 rounded-md"
                    value={employeeNumber}
                    onChange={(e) => setEmployeeNumber(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 p-2 rounded-md bg-gray-100"
                    value={employeeData.employee_fullname}
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    className="w-full border border-gray-300 p-2 rounded-md bg-gray-100"
                    value={employeeData.employee_email}
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Contact No
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 p-2 rounded-md bg-gray-100"
                    value={employeeData.employee_contact_no}
                    readOnly
                  />
                </div>
              </div>
              <div className="flex justify-end items-center p-4 bg-gray-50 border-t space-x-3">
                {successMessage && (
                  <p className="text-green-600 text-sm">{successMessage}</p>
                )}
                {errorMessage && (
                  <p className="text-red-600 text-sm">{errorMessage}</p>
                )}
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
                  onClick={togglePopup}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50"
                  disabled={
                    loading ||
                    !employeeData.employee_fullname ||
                    employeeData.employee_fullname === "Not Found"
                  }
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isDeleteConfirmOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-lg font-semibold mb-4">
              Are you sure you want to delete this supervisor?
            </h3>
            <div className="flex justify-end gap-4">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={confirmDelete}
              >
                Yes, Delete
              </button>
              <button
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
                onClick={cancelDelete}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Supervisors;
